import { render, staticRenderFns } from "./service.vue?vue&type=template&id=335fe8b8&scoped=true&"
var script = {}
import style0 from "./service.vue?vue&type=style&index=0&id=335fe8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335fe8b8",
  null
  
)

export default component.exports